/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowActivity200ResponseDataUser
 */
export interface ShowActivity200ResponseDataUser {
    /**
     * 
     * @type {number}
     * @memberof ShowActivity200ResponseDataUser
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataUser
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataUser
     */
    username?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataUser
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataUser
     */
    avatarUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataUser
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataUser
     */
    country?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ShowActivity200ResponseDataUser
     */
    isAdmin?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataUser
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ShowActivity200ResponseDataUser
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ShowActivity200ResponseDataUser interface.
 */
export function instanceOfShowActivity200ResponseDataUser(value: object): value is ShowActivity200ResponseDataUser {
    return true;
}

export function ShowActivity200ResponseDataUserFromJSON(json: any): ShowActivity200ResponseDataUser {
    return ShowActivity200ResponseDataUserFromJSONTyped(json, false);
}

export function ShowActivity200ResponseDataUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowActivity200ResponseDataUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'username': json['username'] == null ? undefined : json['username'],
        'bio': json['bio'] == null ? undefined : json['bio'],
        'avatarUrl': json['avatar_url'] == null ? undefined : json['avatar_url'],
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'isAdmin': json['is_admin'] == null ? undefined : json['is_admin'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ShowActivity200ResponseDataUserToJSON(json: any): ShowActivity200ResponseDataUser {
    return ShowActivity200ResponseDataUserToJSONTyped(json, false);
}

export function ShowActivity200ResponseDataUserToJSONTyped(value?: ShowActivity200ResponseDataUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'username': value['username'],
        'bio': value['bio'],
        'avatar_url': value['avatarUrl'],
        'city': value['city'],
        'country': value['country'],
        'is_admin': value['isAdmin'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

